exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-invite-___style__form___2VTvx{padding:1em 0 0;min-width:570px}.web-flows-deal-invite-___style__email_label___3AY_I{display:block;padding:.4em 0}.web-flows-deal-invite-___style__email_input___1Tbwc{display:block;width:100%;margin-bottom:1em}.web-flows-deal-invite-___style__header___LezYv{display:flex;justify-content:space-between;border-bottom:1px solid #e5e3e3}.web-flows-deal-invite-___style__h2___2MgfG{border-bottom:none!important}.web-flows-deal-invite-___style__close___2E5Eu{padding:0 .7em .7em 0}@media (max-width:599px){.web-flows-deal-invite-___style__toplevel___2tKOe{padding:1em .5em 0}.web-flows-deal-invite-___style__form___2VTvx{min-width:auto}}", ""]);

// exports
exports.locals = {
	"form": "web-flows-deal-invite-___style__form___2VTvx",
	"email_label": "web-flows-deal-invite-___style__email_label___3AY_I",
	"email_input": "web-flows-deal-invite-___style__email_input___1Tbwc",
	"header": "web-flows-deal-invite-___style__header___LezYv",
	"h2": "web-flows-deal-invite-___style__h2___2MgfG",
	"close": "web-flows-deal-invite-___style__close___2E5Eu",
	"toplevel": "web-flows-deal-invite-___style__toplevel___2tKOe"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/invite/style.css
// module id = 1345
// module chunks = 0